<template>
  <div
    class="main__div my-3 mb-5"
    :class="$vuetify.breakpoint.xsOnly ? 'px-5' : ''"
  >
    <!-- <ProfileCard
      :profile_object="profile_object"
      :is_user_profile="false"
    ></ProfileCard> -->
    <user-profile-card
      :profile_object="profile_object"
      :is_user_profile="false"
    ></user-profile-card>

    <profile-page-my-group-row
      :user-id="$route.params.id"
    ></profile-page-my-group-row>
    <!-- <DisplayVideosComponentForOtherProfiles></DisplayVideosComponentForOtherProfiles> -->

    <div class="px-5">
      <profile-video-listing
        :user_id="$route.params.id"
      ></profile-video-listing>
    </div>
    <div class="px-sm-5" id="tradeslist">
      <!-- <profile-trade-detail
        :user_id="user"
        @viewTrade="viewTrade"
        @getProfileDetails="getProfileDetails"
      ></profile-trade-detail> -->
      <profile-trades
        :user_id="parseInt(user)"
        @viewTrade="viewTrade"
        @getProfileDetails="getProfileDetails"
      ></profile-trades>
    </div>
    <!-- <trade-detail-dialog></trade-detail-dialog> -->

    <!-- <trade-detail-form
      v-if="trade_detail_form.flag"
      @reload-profile="$emit('reloadProfile')"
      :trade_detail_form="trade_detail_form"
      @reload-trades="$emit('reloadTrades')"
      @reload-trade-data="getTradeList(0)"
      @reload-trade-data-comment="getTradeAfterComment"
    /> -->
  </div>
</template>

<script>
// import DisplayVideosComponentForOtherProfiles from "../../components/Profile/VideoCourse/DisplayVideosComponentForOtherProfiles.vue";
import Axios from "@/api/BaseAxios.js";
import { isAuthenticated } from "../../common/commonFunctions";
// import TradeDetailForm from "@/components/Trade/TradeDetailForm.vue";
// import ProfileCard from "@/components/Profile/ProfileCard.vue";
import ProfilePageMyGroupRow from "@/components/ProfilePageMyGroupRow.vue";
import { mapActions } from "vuex";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "OthersProfilePage",
  components: {
    // DisplayVideosComponentForOtherProfiles,
    // ProfileCard,
    // TradeDetailForm,
    ProfilePageMyGroupRow,
    // ProfileTradeDetail: () =>
    //   import("@/components/Profile/ProfileTradeDetails/ProfileTradeDetails"),
    ProfileVideoListing: () =>
      import("../../components/VideoCourse/ProfileListing/ProfileListing.vue"),
    ProfileTrades: () =>
      import("@/components/Profile/ProfileTradeDetails/ProfileTrades"),
    UserProfileCard: () => import("@/components/Profile/UserProfileCard.vue"),
    // TradeDetailDialog: () => import("@/components/Trade/TradeDetailDialog"),
  },
  data: () => ({
    menu: false,
    showFill: false,
    user: null,
    dates: [],
    profile_object: {},
    trades: [],
    hidefilters: true,
    profileLoading: false,
    tradesLoading: false,
    statusItems: [
      { name: "Live", value: "Active" },
      { name: "Upcoming", value: "Inactive" },
      { name: "Closed", value: "Closed" },
    ],
    buysellItems: ["Buy", "Sell"],

    durationItems: [
      { name: "Intra-day", value: "Intra-day-BTST (1~2 days)" },
      { name: "Short-term", value: "Short term (1~2 weeks)" },
      { name: "Intermediate", value: "Intermediate (2~6 weeks)" },
      { name: "Long-term", value: "Long term (>6 weeks)" },
    ],
    duration: [],
    status: [],
    buy_sell: [],
    sorts: null,
    hide: true,
    trade_form_data: {
      flag: false,
      id: null,
    },
    trade_detail_form: {
      flag: false,
      id: null,
    },
    page: 1,
    pageNum: 1,
    selectedTab: 0,
    tradeCount: { posted: 0, followed: 0 },
    expansion: [
      { title: `Today’s Trades`, flag: true, count: 0, items: [] },
      {
        title: `Previous Week’s Trades`,
        flag: true,
        count: 0,
        items: [],
      },
      {
        title: `Other Previous Trades`,
        flag: true,
        count: 0,
        items: [],
      },
    ],
  }),

  metaInfo() {
    return {
      title: `${this.profile_object.name}`,
      meta: [
        {
          name: "description",
          content:
            "Connect and follow " +
            this.profile_object.name +
            " on Covesto - Individual investing to community covesting",
        },
        {
          property: "og:title",
          content: this.profile_object.name + " - Covesto",
        },
        { property: "og:site_name", content: "Covesto" },
        {
          property: "og:description",
          content:
            "Connect and follow " +
            this.profile_object.name +
            " on Covesto - Individual investing to community covesting",
        },
        { property: "og:type", content: "profile" },
        {
          property: "og:url",
          content: "https://covesto.in" + this.profile_object.id,
        },
        {
          property: "og:image",
          itemprop: "image",
          content: "https://api.covesto.in" + this.profile_object.profile_image,
        },
      ],
    };
  },
  watch: {
    dates(value) {
      // filterTrades
      if (value.length < 2) {
        console.log(value);
        this.filterTrades();
      }
    },
  },
  computed: {
    dateFormattedText: {
      get() {
        if (this.dates.length) {
          if (this.dates.length == 1) {
            return this.moment(this.dates[0]).format("MMM-DD");
          } else {
            return `${this.moment(this.dates[0]).format(
              "MMM-DD"
            )},${this.moment(this.dates[1]).format("MMM-DD")}`;
          }
        } else {
          return "";
        }
      },
    },
    is_calender_data: {
      get() {
        if (
          !this.expansion[0].items.length &&
          !this.expansion[1].items.length &&
          !this.expansion[2].items.length
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    is_filter: {
      get() {
        if (
          this.status.length ||
          this.buy_sell.length ||
          this.duration.length ||
          this.dates.length
        ) {
          return true;
        } else if (
          !this.expansion[0].items.length &&
          !this.expansion[1].items.length &&
          !this.expansion[2].items.length
        ) {
          return true;
        } else {
          return false;
        }
      },
      set() {
        return (this.status = []), (this.buy_sell = []), (this.duration = []);
      },
    },
  },
  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleTradeDetailModal: "tradeCardDialog/toggleModal",
    }),
    getProfileDetails() {
      const user_id = this.$route.params.id;
      const successHandler = (res) => {
        // console.log(res);
        this.profile_object = res.data.result;
        // console.log(this.profile_object, "profile data");
        this.$store.state.Auth.userProfileTitle = this.profile_object.name;
        this.$store.state.Auth.userProfileId = this.$route.params.id;
        // console.log(this.profile_object);
        console.log("this is priifile loaded");

        console.log(
          this.$store.state.Auth.is_logged_in,
          this.$store.state.Auth.isPrivate,
          this.$store.state.Auth.checkStatus,
          this.$store.state.Auth.checkStatus
        );
        console.log(
          !this.$store.state.Auth.isPrivate &&
            this.$store.state.Auth.is_logged_in &&
            this.$store.state.Auth.checkStatus === "USERPROFILE",
          "conditions"
        );
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      let formData = {};
      if (commonFunctions.getUserId()) {
        formData["request_user"] = commonFunctions.getUserId();
      }
      Axios.request_GET(
        `api/profile-details/${user_id}`,
        formData,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    viewTrade(id) {
      this.trade_detail_form.flag = true;
      this.trade_detail_form.id = id;
    },
    getTrades(item) {
      this.status = [];
      this.buy_sell = [];
      this.selectedTab = item;
      this.duration = [];
      this.dates = [];
      this.hide = false;
      this.page = 1;
      this.pageNum = 1;
      this.getTradeList();
      this.tradesLoading = true;
    },
    getTradeAfterComment() {
      this.page = 1;
      this.getTradeList(0);
    },
    filterTrades(item) {
      this.hidefilters = false;
      this.tradesLoading = true;
      this.page = 1;
      this.getCount();
      console.log(item, "this was item");
      const user_id = this.$route.params.id;
      const successHandler = (res) => {
        console.log(res, "this si tesilts");
        if (item == "append") {
          console.log(this.trades, "this are trades");
          res.data.results.forEach((i) => {
            this.trades.push(i);
          });
          this.numPages = res.data.num;
        } else {
          this.trades = [];
          this.trades = res.data;
          // this.numPages = res.data.num;
          // setTimeout(() => {
          this.tradesLoading = false;
          // }, 1000);
        }
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      console.log(this.selectedTab, "tab");
      Axios.request_GET(
        `api/trade/filter-trades/${this.selectedTab}/${user_id}/${this.page}/${
          this.status == "" ? null : this.status
        }/${this.buy_sell == "" ? null : this.buy_sell}/${
          this.duration == "" ? null : this.duration
        }/${this.dates.length ? this.dates : null}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    getTradeList(item) {
      this.getCount();

      const user_id = this.$route.params.id;

      const successHandler = (res) => {
        if (item == "append") {
          res.data.other.forEach((i) => {
            this.expansion[2].items.push(i);
          });
          this.numPages = res.data.num;
        } else {
          this.trades = [];
          this.trades = res.data.result;
          this.numPages = res.data.num;
          this.expansion[0].count = res.data.count.trade_today;
          this.expansion[1].count = res.data.count.trade_past_week;
          this.expansion[2].count = res.data.count.trade_other;
          this.expansion[0].items = res.data.today;
          this.expansion[1].items = res.data.past_week;
          this.expansion[2].items = res.data.other;
          setTimeout(() => {
            this.tradesLoading = false;
            this.hidefilters = false;
          }, 500);
        }
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      console.log(this.selectedTab, "tab");
      Axios.request_GET(
        `api/trade/trade-list/${user_id}/${this.selectedTab}/${this.page}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    getCount() {
      const user_id = this.$route.params.id;
      const successHandler = (res) => {
        this.tradeCount.posted = res.data.posted_count;
        this.tradeCount.followed = res.data.followed_count;
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/get-trades-count/${user_id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    onIntersect(entries, observer) {
      console.log(entries, observer);
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.page += 1;
          if (this.page <= this.numPages) {
            this.getTradeList("append");
          } else {
            this.hide = false;
          }
        }
      });
    },
  },
  beforeMount() {
    this.user = this.$route.params.id;
  },
  created() {
    const user_id = this.$route.params.id;
    const user = commonFunctions.getUserId();
    console.log(user_id, user);
    if (parseInt(user_id) == parseInt(user)) {
      this.$router.push({
        name: "ProfilePage",
        query: {
          trade_id: this.$route.query.trade_id,
          fotrade: this.$route.query.fotrade,
        },
      });
    }
    this.eventBus.$on("update-profile-detail", () => {
      this.getProfileDetails();
    });
  },
  beforeDestroy() {
    this.eventBus.$off("update-profile-detail");
  },
  mounted() {
    this.tradesLoading = true;
    this.getProfileDetails();
    this.$logEvent("expert_profile_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_expert_profile_view");
    }
    if (this.$route.query.trade_id) {
      // this.viewTrade(this.$route.query.trade_id);
      // console.log(this.$route.query.trade_id);
      this.toggleTradeDetailModal({
        show: true,
        id: this.$route.query.trade_id,
      });
    }
    if (!isAuthenticated()) {
      this.$store.state.Auth.checkStatus = "USERPROFILE";
    }
  },
};
</script>

<style scoped>
@media all and (max-width: 600px) {
  .main__div {
    background-color: #f2f8ff !important;
    min-height: 100vh !important;
    width: 100% !important;
    overflow-x: hidden;
  }
  .trades_list__div {
    width: 100% !important;
    margin: 0px !important;
  }
  .tab,
  .trade-tabs {
    height: 60px;
    width: 100% !important;
  }
  p {
    font-size: 17px !important;
    padding-top: 10px;
    font-weight: 900;
  }
  .title {
    justify-content: space-between !important;
    display: flex;
    padding: 20px 0px !important;
  }
  .tab {
    width: 100%;
  }
  .trade-cards-container {
    grid-template-columns: auto !important;
    padding: 0px;
  }
  .trade-card {
    width: 100% !important;
    padding: 0px !important;
  }
  /* .main__div {
    padding: 0px !important;
  }*/
  .sort-and-filter {
    width: 100% !important;
    text-align: center !important;
    margin-left: 5px;
  }
}

.add-trade-button {
  letter-spacing: 0px;
  font-size: 16px;
}
.selectBox {
  margin: 10px 10px 0px 0px;
  height: 45px !important;
}
.sort-and-filter {
  width: 800px;
}
.main__div {
  background-color: #f2f8ff !important;
  min-height: 100vh !important;
  width: 100%;
  margin: 0px !important;
}
.trades_list__div {
  min-height: 58vh;
  margin: 20px;
  background: #f2f8ff !important;
}
.title {
  display: flex;
  justify-content: space-between;
}
.tradeListHeading {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 27px;

  color: #333333;
}
p {
  font-size: 18px;
  font-weight: 800;
}
.add-trade-button {
  text-transform: capitalize;
  color: #fff;
}
.trade-cards-container {
  display: grid;
  grid-template-columns: repeat(3, 31.2%);
  justify-content: space-between;
  grid-row-gap: 30px;
  margin-top: 20px;
  width: 100% !important;
}
.trade-card {
  width: 100%;
}
.trade-tabs {
  background: #f2f8ff !important;
  text-transform: capitalize;
}
.tab {
  width: 200px;
  text-transform: none;
}
</style>
